import { EthereumProvider } from '@walletconnect/ethereum-provider';

import { WalletError } from '@/types';
import { Connector, ConnectorId } from '../connector';
import configs, { Network } from '@/lib/config';
import useDarkMode from '@/composables/useDarkMode';
import { EthereumRpcMap } from '@walletconnect/ethereum-provider/dist/types/EthereumProvider';

const { CELO, POLYGON, ALFAJORES, AMOY, BASE_SEPOLIA, SEPOLIA } = Network;

const SUPPORTED_CHAINS = [
  CELO,
  POLYGON,
  ALFAJORES,
  AMOY,
  BASE_SEPOLIA,
  SEPOLIA,
] as Network[];

export class WalletConnectConnector extends Connector {
  id = ConnectorId.WalletConnect;
  async connect() {
    const provider = await EthereumProvider.init({
      projectId: '5944534b2f4497f40b24668f17fac113',
      optionalChains: SUPPORTED_CHAINS,
      rpcMap: SUPPORTED_CHAINS.reduce<EthereumRpcMap>((obj, chainId) => {
        obj[chainId] = configs[chainId].rpc;
        return obj;
      }, {}),
      showQrModal: true,
      qrModalOptions: { themeMode: useDarkMode().darkMode ? 'dark' : 'light' },
    });

    this.provider = provider;

    try {
      const accounts = await provider.enable();
      const chainId = await provider.request({ method: 'eth_chainId' });
      this.handleChainChanged(chainId);
      this.handleAccountsChanged(accounts);
    } catch (err) {
      if ((err as WalletError).code === 4001) {
        // EIP-1193 userRejectedRequest error
        // If this happens, the user rejected the connection request.
        console.log('Please connect to WalletConnect.');
      } else {
        console.error(err);
      }
    }
    return {
      provider,
      account: this.account,
      chainId: this.chainId,
    };
  }
}
